import React from 'react';
import styles from './TableActionCell.module.scss';

const TableActionCell = () => {
  return <div className={styles.tableActionCell} />;
};

export default TableActionCell;
